import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ConfirmDialog = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = "Confirm Action",
    message = "Are you sure you want to proceed?",
    confirmText = "Confirm",
    cancelText = "Cancel",
    confirmColor = "danger" // "danger", "primary", "success"
}) => {
    if (!isOpen) return null;

    const iconConfig = {
        danger: {
            icon: "bi bi-exclamation-triangle-fill",
            badge: "bg-danger bg-opacity-10 text-danger"
        },
        primary: {
            icon: "bi bi-info-circle-fill",
            badge: "bg-primary bg-opacity-10 text-primary"
        },
        success: {
            icon: "bi bi-check-circle-fill",
            badge: "bg-success bg-opacity-10 text-success"
        }
    };

    const config = iconConfig[confirmColor] || iconConfig.danger;

    return (
        <>
            {/* Modal Backdrop */}
            <div 
                className="modal fade show d-block" 
                tabIndex="-1" 
                style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                onClick={onClose}
            >
                <div 
                    className="modal-dialog modal-dialog-centered"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="modal-content border-0 shadow-lg">
                        {/* Modal Header */}
                        <div className="modal-header border-0 pb-0">
                            <div className="d-flex align-items-start w-100">
                                <div className={`p-3 rounded-3 me-3 ${config.badge}`}>
                                    <i className={`${config.icon} fs-4`}></i>
                                </div>
                                <div className="flex-grow-1 mt-1">
                                    <h5 className="modal-title fw-semibold mb-0">
                                        {title}
                                    </h5>
                                </div>
                                <button 
                                    type="button" 
                                    className="btn-close" 
                                    onClick={onClose}
                                ></button>
                            </div>
                        </div>

                        {/* Modal Body */}
                        <div className="modal-body pt-2">
                            <p className="text-secondary mb-0">{message}</p>
                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer border-0 pt-0">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onClose}
                            >
                                {cancelText}
                            </button>
                            <button
                                type="button"
                                className={`btn btn-${confirmColor}`}
                                onClick={() => {
                                    onConfirm();
                                    onClose();
                                }}
                            >
                                {confirmText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ConfirmDialog;


/* ========================================
   DEMO USAGE EXAMPLE
   ======================================== */

// App.js
/*
import React, { useState } from 'react';
import ConfirmDialog from './ConfirmDialog';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {
    const [showDialog, setShowDialog] = useState(false);

    const handleDelete = () => {
        alert('Team deleted successfully!');
    };

    return (
        <div className="container py-5">
            <div className="card shadow-sm">
                <div className="card-body">
                    <h3 className="card-title">Team Management</h3>
                    <p className="card-text text-muted">
                        Manage your team settings and members
                    </p>
                    
                    <button 
                        className="btn btn-danger"
                        onClick={() => setShowDialog(true)}
                    >
                        Delete Team
                    </button>
                </div>
            </div>

            <ConfirmDialog
                isOpen={showDialog}
                onClose={() => setShowDialog(false)}
                onConfirm={handleDelete}
                title="Delete Team"
                message="Are you sure you want to delete this team? This action cannot be undone."
                confirmText="Delete"
                cancelText="Cancel"
                confirmColor="danger"
            />
        </div>
    );
}

export default App;
*/

/* ========================================
   INSTALLATION COMMANDS
   ======================================== 
   
   npm install bootstrap bootstrap-icons
   
   OR
   
   yarn add bootstrap bootstrap-icons
   
   ======================================== */